import React from 'react';

import { cn } from '@/shared/utils';
import { CardProps } from '@/types/ui/uiTypes';

const Card: React.FC<CardProps> = ({
  children,
  className,
  title,
  subtitle,
  action,
  onClick,
  interactive = true,
}) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (!onClick) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={cn(
        'rounded-lg border border-gray-100 bg-white p-6 shadow-sm',
        interactive && 'shadow-blue-100/50',
        !interactive && 'shadow-blue-100/50',
        onClick &&
          'cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2a1b63] focus-visible:ring-offset-2',
        className,
      )}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={handleKeyDown}
    >
      {(title || subtitle || action) && (
        <div className="mb-4">
          <div className="flex items-center justify-between">
            {title && <h3 className="mb-1 text-lg font-semibold text-gray-900">{title}</h3>}
            {action && <div>{action}</div>}
          </div>
          {subtitle && <p className="text-sm text-gray-600">{subtitle}</p>}
        </div>
      )}
      {children}
    </div>
  );
};

export default Card;
